module.exports = __webpack_public_path__ + "img/ji7a.f8ebc222.png";